/**
 * Created by frank.law on 11/13/17.
 */
import {
    REQUEST_BEGIN,
    REQUEST_END,
    RESPONSE_ERROR,
    SUBMIT_INIT_CHALLENGE,
    SUBMIT_INIT_RESET_CHALLENGE,
    SUBMIT_USERNAME_CHALLENGE,
    SUBMIT_PASSWORD_CHALLENGE,
    SUBMIT_RESET_PASSWORD_CHALLENGE,
    SUBMIT_TOTP_SETUP_CHALLENGE,
    SUBMIT_TOTP_VERIFY_CHALLENGE,
    SUBMIT_FORGOT_PASSWORD_CHALLENGE,
    SUBMIT_RESEND_LINK,
    SUBMIT_BACKUP_CODES_CHALLENGE,
    SUBMIT_STANDARD_LOGIN_REQUEST,
    SUBMIT_INIT_STANDARD_LOGIN_CHALLENGE,
    SUBMIT_INIT_STANDARD_LOGIN_REQUEST,
    SUBMIT_INIT_STANDARD_LOGIN_SENT
} from '../actions/actions';

import {
    requestBegin,
    requestEnd,
    inputError,
    challengeSuccess,
    responseError,
    showUserMessage,
    updateAppLogo,
    updateOAuthProperties,
    updateResetToken,
    redirectToUrl,
    submitSamlRequest,
    submitRegionRedirectRequest,
    submitStandardLoginRegionRedirect,
    submitInitStandardLoginSent
} from '../actions/actions';

import APIUtility from '../utils/APIUtility';

const loginEndpoint = process.env.REACT_APP_LOGIN_ENDPOINT;


const loginAPIMiddleware = ({dispatch}) => next => action => {

    // Displays the response error page (band-aids page).
    const errorFunction = function(error) {
        let errorResponse = error.body;
        if (errorResponse.nextChallenge != null && errorResponse.nextChallenge.nextChallenge === 'redirect') {
            dispatch(redirectToUrl(errorResponse.nextChallenge.targetUrl, errorResponse.nextChallenge.state, '', undefined));
        } else {
            dispatch(responseError(error));
        }
    };

    // Catches and displays error messages as red subtext for responses with the given status codes.
    // Otherwise displays the response error page (band-aids page).
    const catchInputError = function(statusCodes) {
        return function(response) {
            if (statusCodes.indexOf(response.status) > -1) {
                try {
                    dispatch(inputError(response.body.error));
                } catch (e) {
                    dispatch(inputError(JSON.stringify(response.body)));
                }
            } else {
                errorFunction(response);
            }
        }
    };

    if (action.type === SUBMIT_INIT_CHALLENGE) {
        dispatch(requestBegin(action.type));
        // Save the OAuth Properties to the state object.
        dispatch(updateOAuthProperties(action.responseType, action.clientId, action.redirectURI, action.clientState, action.redirect,
            action.codeChallenge, action.codeChallengeMethod, action.prompt, action.username));

        const body = {
            challenge : 'init',
            client_id: action.clientId,
            response_type: action.responseType,
            redirect_uri: action.redirectURI,
            state: action.clientState,
            redirect: action.redirect,
            tenantAlias: action.tenantAlias,
            tenantName: action.tenantName,
            tenantURL: action.tenantURL,
            code_challenge: action.codeChallenge,
            code_challenge_method: action.codeChallengeMethod,
            prompt: action.prompt,
            username: action.username
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function (response) {
            dispatch(requestEnd(action.type));
            if (response.nextChallenge.nextChallenge === 'redirect') {
                dispatch(redirectToUrl(response.nextChallenge.targetUrl, response.nextChallenge.state, '', undefined));
            } else if (response.nextChallenge.nextChallenge === 'submit_saml_request') {
                dispatch(submitSamlRequest(response.nextChallenge.ssoEndpoint, response.nextChallenge.authnRequest,
                    response.nextChallenge.state, response.nextChallenge.signatureAlgorithm))
            } else {
                if (response.nextChallenge.nextChallenge !== 'complete') {
                    // Only look for app logo if not complete state.
                    dispatch(updateAppLogo(response.nextChallenge.prompts.appName.value, response.nextChallenge.prompts.appLogo.value));
                }
                dispatch(challengeSuccess(response));
            }
        }, errorFunction);
    } else if (action.type === SUBMIT_INIT_RESET_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge : 'init_reset',
            resetToken: action.resetToken
        };

        // Save the reset password token.
        dispatch(updateResetToken(action.resetToken));

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(updateAppLogo(response.nextChallenge.prompts.appName.value, response.nextChallenge.prompts.appLogo.value));
            dispatch(challengeSuccess(response));
        }, errorFunction );
    } else if (action.type === SUBMIT_USERNAME_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            token: action.token
        };

        if (action.challenge === 'user') {
            body.username = action.username;
        } else {
            body.tenantAlias = action.username;
        }

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            if ((response.nextChallenge != null) && (response.nextChallenge.nextChallenge === 'redirect')) {
                dispatch(redirectToUrl(response.nextChallenge.targetUrl, response.nextChallenge.state, '', undefined))
            } else if ((response.nextChallenge != null) && (response.nextChallenge.nextChallenge === 'submit_saml_request')) {
                dispatch(submitSamlRequest(response.nextChallenge.ssoEndpoint, response.nextChallenge.authnRequest,
                    response.nextChallenge.state, response.nextChallenge.signatureAlgorithm))
            } else if ((response.nextChallenge != null) && (response.nextChallenge.nextChallenge === 'regional')) {
                dispatch(submitRegionRedirectRequest(response.nextChallenge.redirectEndpoint, response.nextChallenge.username))
            } else {
                dispatch(challengeSuccess(response));
            }
        }, catchInputError([404]));
    } else if (action.type === SUBMIT_PASSWORD_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            password: action.password,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, catchInputError([401, 404]));
    } else if (action.type === SUBMIT_TOTP_VERIFY_CHALLENGE) {

        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            authCode: action.authCode,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, catchInputError([400]));
    } else if (action.type === SUBMIT_RESET_PASSWORD_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            password: action.newPassword,
            passwordAgain: action.newPasswordConfirmation,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, catchInputError([400, 401]));
    } else if (action.type === SUBMIT_TOTP_SETUP_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, catchInputError([400, 401]));
    } else if (action.type === SUBMIT_FORGOT_PASSWORD_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, errorFunction);
    } else if (action.type === SUBMIT_RESEND_LINK) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            token: action.token,
            resetToken: action.resetToken
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, errorFunction);
    } else if (action.type === SUBMIT_BACKUP_CODES_CHALLENGE) {
        dispatch(requestBegin(action.type));
        const body = {
            challenge: action.challenge,
            token: action.token
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, errorFunction);
    } else if (action.type === SUBMIT_STANDARD_LOGIN_REQUEST) {
        dispatch(requestBegin(action.type));
        const body = {
            email: action.email
        };

        // Build the endpoint URL with optional PKCE query parameters
        let standardLoginEndpoint = process.env.REACT_APP_STANDARD_LOGIN_ENDPOINT;
        const params = new URLSearchParams();
        if (action.codeChallenge) {
            params.append('code_challenge', action.codeChallenge);
        }
        if (action.codeChallengeMethod) {
            params.append('code_challenge_method', action.codeChallengeMethod);
        }
        if (params.toString()) {
            standardLoginEndpoint += '?' + params.toString();
        }
        APIUtility.makePostRequest(standardLoginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            if (response.redirectUrl && response.redirectEmail) {
                // User's primary region differs from current. POST to primary region with email in body
                // (like createRegionalRedirectResponse), so email is not in the URL and not logged.
                dispatch(submitStandardLoginRegionRedirect(
                    response.redirectUrl,
                    response.redirectEmail,
                    response.redirectCodeChallenge || null,
                    response.redirectCodeChallengeMethod || null
                ));
            } else {
                dispatch(submitInitStandardLoginSent());
            }
        }, function(error) {
            dispatch(requestEnd(action.type));
            // Still show success message for security (don't reveal if email exists).
            dispatch(submitInitStandardLoginSent());
        });
    } else if (action.type === SUBMIT_INIT_STANDARD_LOGIN_SENT) {
        // Fetches the localized "login link sent" confirmation challenge from the backend
        // and renders it with the same reset_sent UI used by the forgot password flow.
        dispatch(requestBegin(action.type));
        const body = {
            challenge: 'init_standard_login_sent'
        };
        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, errorFunction);
    } else if (action.type === SUBMIT_INIT_STANDARD_LOGIN_REQUEST) {
        // Fetches the localized "Request Standard Login" form challenge from the backend
        // so the form's title, body, email label/placeholder, and submit label are driven
        // by conf/messages rather than hardcoded in React.
        dispatch(requestBegin(action.type));
        const body = {
            challenge: 'init_standard_login_request'
        };
        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            dispatch(challengeSuccess(response));
        }, errorFunction);
    } else if (action.type === SUBMIT_INIT_STANDARD_LOGIN_CHALLENGE) {
        // Standard login redirect uses the same init_reset challenge as password reset
        // The backend differentiates based on the link type (STANDARD_LOGIN_LINK vs RESET_PASSWORD_LINK)
        dispatch(requestBegin(action.type));
        const body = {
            challenge: 'init_reset',
            resetToken: action.magicToken
        };

        APIUtility.makePostRequest(loginEndpoint, action.type, JSON.stringify(body), function(response) {
            dispatch(requestEnd(action.type));
            if (response.nextChallenge.nextChallenge === 'redirect') {
                dispatch(redirectToUrl(response.nextChallenge.targetUrl, response.nextChallenge.state, ''));
            } else {
                dispatch(updateAppLogo(response.nextChallenge.prompts.appName.value, response.nextChallenge.prompts.appLogo.value));
                dispatch(challengeSuccess(response));
            }
        }, errorFunction);
    } else if (action.type === REQUEST_BEGIN || action.type === REQUEST_END) {
        // Valid action, but nothing for LoginAPIMiddleware to do
    } else if (action.type === RESPONSE_ERROR) {
        // Some irrecoverable error.
        if (action.error.body) {
            dispatch(showUserMessage(action.error.body.title, action.error.body.error, "message", action.error.body.iconName));
        } else {
            dispatch(showUserMessage("Hmm... Something went wrong",
                "Workday has been notified and is currently working to resolve the issue.",
                "message", "band-aids"));
        }
    } else {
        // Unsupported Request
        dispatch(requestEnd(action.type));
    }

    next(action);
};

export default loginAPIMiddleware;
